import { API } from 'lib';
import { SaveResponsePayload } from 'pages/Forms/types/submission';
import { ENDPOINTS } from './keysAndEndpoints';
import {
  SaveInfoParams,
  SendVerificationCodeParams,
  VerifyGuestOTPParams,
} from '../types/api';

export const sendVerificationCode = async (
  params: SendVerificationCodeParams,
) => {
  const response = await API.post(ENDPOINTS.SEND_GUEST_OTP, params);
  return response;
};

export const verifyGuestOTP = async (params: VerifyGuestOTPParams) => {
  const response = await API.post(ENDPOINTS.VERIFY_GUEST_OTP, params);
  return response;
};

export const saveInfo = async (params: SaveInfoParams) => {
  const response = await API.post(ENDPOINTS.SAVE_INFO, params);
  return response;
};

export const verifyFormLink = async (id: string) => {
  const response = await API.get(ENDPOINTS.VERIFY_FORM_LINK(id));
  return response;
};

export const fetchFormDataById = async (id: string) => {
  const response = await API.get(ENDPOINTS.FETCH_FORM_DATA_BY_ID(id));
  return response.data.data;
};

export const saveResponse = async (payload: SaveResponsePayload) => {
  const response = await API.post(ENDPOINTS.SAVE_RESPONSE, payload);
  return response;
};
